

export enum UserRole {
  VIEWER = 'Leitura/Consulta',
  PUBLISHER = 'Publicação',
  ADMIN = 'Administrador'
}

export interface User {
  id: string;
  fullName: string;
  username: string;
  email: string;
  sector: string;
  role: UserRole;
  avatar?: string;
  mustChangePassword?: boolean; // New flag to force password change
}

export interface Sector {
  id: string;
  name: string;
  parentId?: string | null; // Add this property for hierarchical structure, allowing null
}

export enum ArticleStatus {
  PENDING = 'Pendente de Aprovação',
  APPROVED = 'Aprovado',
  REJECTED = 'Rejeitado'
}

export interface Attachment {
  id: string;
  name: string;
  url: string;
  type: string;
}

export interface Article {
  id: string;
  title: string;
  content: string; // Markdown
  authorId: string;
  authorName: string;
  sectorId: string;
  sectorName: string;
  status: ArticleStatus;
  createdAt: string;
  updatedAt: string;
  tags: string[];
  attachments?: Attachment[];
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'model';
  text: string;
  timestamp: number;
}

export interface ChatSession {
  id: string;
  userId: string;
  title: string;
  messages: ChatMessage[];
  createdAt: number;
  updatedAt: number;
}

export interface AppSettings {
  logoUrl?: string;
  loginBackgroundImageUrl?: string;
  appName?: string; // Added appName
  primaryColor?: string; // Added primaryColor
  lastUpdatedAt?: number; // New: Timestamp for last update, used for cache busting
  claudeInitialBalance?: number; // Prepaid credits recarregado
  claudeCreditsRemaining?: number; // Créditos restantes estimados
  claudeTotalSpent?: number; // Total gasto acumulado estimado
}

export interface MaintenanceSettings {
  isMaintenanceMode: boolean;
  message: string;
}

export type ViewState = 'login' | 'dashboard' | 'chat' | 'submit' | 'my-articles' | 'admin' | 'migration' | 'article-view' | 'approvals';

// Fix: Add an empty export to ensure this file is treated as a module.
export {};